import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { appointmentFlowsActions } from 'features/appointmentFlows';
const useAppointmentFlows = () => {
  const dispatch = useDispatch();
  const getAppointmentFlow = useCallback(() => dispatch(appointmentFlowsActions.getAppointmentFlow()), [dispatch]);
  const createAppointmentFlow = useCallback(appointment_flow => dispatch(appointmentFlowsActions.createAppointmentFlow(appointment_flow)), [dispatch]);
  const updateAppointmentFlow = useCallback(appointment_flow => dispatch(appointmentFlowsActions.updateAppointmentFlow(appointment_flow)), [dispatch]);
  const deleteAppointmentFlow = useCallback(() => dispatch(appointmentFlowsActions.deleteAppointmentFlow()), [dispatch]);
  const clearLocalActiveAppointmentFlow = useCallback(() => dispatch(appointmentFlowsActions.clearLocalActiveAppointmentFlow()), [dispatch]);

  return {
    getAppointmentFlow,
    createAppointmentFlow,
    updateAppointmentFlow,
    deleteAppointmentFlow,
    clearLocalActiveAppointmentFlow
  };
};

export default useAppointmentFlows;